import api from "@/lib/axios";
import { AdminSettings, StripePrice } from "@/types/stripe";

export enum AdminSettingsKeys {
  GET_SUBSCRIPTION_PRICES = "get-subscription-prices",
  GET_DEFAULT_SUBSCRIPTION_PRICE = "get-default-subscription-price",
  SET_DEFAULT_SUBSCRIPTION_PRICE = "set-default-subscription-price",
  GET_FORCE_ONE_TO_MANY = "get-force-one-to-many",
  SET_FORCE_ONE_TO_MANY = "set-force-one-to-many",
}

export const getSubscriptionPrices = async () => {
  const response = await api.get<StripePrice[]>(
    "/admin-settings/subscription-prices",
  );
  return response.data;
};

export const getDefaultSubscriptionPrice = async () => {
  const response = await api.get<{ priceId: string | null }>(
    "/admin-settings/default-subscription-price",
  );
  return response.data;
};

export const setDefaultSubscriptionPrice = async (priceId: string) => {
  const response = await api.post<AdminSettings>(
    "/admin-settings/default-subscription-price",
    {
      priceId,
    },
  );
  return response.data;
};

export const getForceOneToMany = async () => {
  const response = await api.get<{ forceOneToMany: boolean }>(
    "/admin-settings/force-one-to-many",
  );
  return response.data;
};

export const setForceOneToMany = async (forceOneToMany: boolean) => {
  const response = await api.post<AdminSettings>(
    "/admin-settings/force-one-to-many",
    {
      forceOneToMany,
    },
  );
  return response.data;
};
